"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = exports.parseDate = void 0;

var date_fns_1 = require("date-fns");

var DATE_ONLY_REGEX = new RegExp("^[0-9]{4}-[0-9]{2}-[0-9]{2}$");

function parseDate(dateString) {
  return typeof dateString === "string" && dateString.match(DATE_ONLY_REGEX) ? (0, date_fns_1.parse)(dateString, "yyyy-MM-dd", new Date()) : (0, date_fns_1.parseJSON)(dateString);
}

exports.parseDate = parseDate; // see https://date-fns.org/v2.4.1/docs/format for configs
// by default, will format to 'yyyy-MM-dd'

function formatDate(dateString) {
  var formatString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "yyyy-MM-dd";
  return (0, date_fns_1.format)(parseDate(dateString), formatString);
}

exports.formatDate = formatDate;